import { render, staticRenderFns } from "./SpecialRxHelpModal.vue?vue&type=template&id=1e1f987f&scoped=true"
import script from "./SpecialRxHelpModal.vue?vue&type=script&lang=js"
export * from "./SpecialRxHelpModal.vue?vue&type=script&lang=js"
import style0 from "./SpecialRxHelpModal.vue?vue&type=style&index=0&id=1e1f987f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e1f987f",
  null
  
)

export default component.exports